module.exports = __webpack_public_path__ + "static/img/HDKG_H5.8da2269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HDKG_H5.png
// module id = Qy3K
// module chunks = 34